import { LEVEL_META } from "../lib/constants";
import { cn } from "../lib/utils";

export function LevelBadge({ level, full = false, className, ...rest }) {
  if (!level) {
    return (
      <span {...rest} data-testid={rest["data-testid"] || "level-badge"} className={cn("inline-flex items-center rounded border px-2 py-0.5 text-xs font-semibold border-border text-muted-foreground", className)}>
        Da profilare
      </span>
    );
  }
  const meta = LEVEL_META[level];
  return (
    <span {...rest} data-testid={rest["data-testid"] || "level-badge"} className={cn("inline-flex items-center gap-1.5 rounded border px-2 py-0.5 text-xs font-semibold", meta.className, className)}>
      <span aria-hidden>{meta.dot}</span> {full ? meta.full : meta.label}
    </span>
  );
}
